module.exports = __webpack_public_path__ + "img/Weapon_178.7eb76e02.png";